export enum MyProjectTabIdEnum {
    'READY_TO_APPROVE',
    'APPROVAL_DONE',
    'ALL',
    'OPENED',
    'CLOSED',
    'HARDWARE',
    'SUPPLY'
}
